<div class="master_uploader">
  <div class="img_uploader">
    <p>Upload
      <span *ngIf="type === 'IMAGE'"> Image </span>
      <span class="dimensions" *ngIf="type === 'IMAGE'">(450 ✕ 500 - Png, Jpg, Jpeg)</span>
      <span *ngIf="type === 'VIDEO'"> Video (Max: 25MB) </span>
      <span *ngIf="type === 'FILE'"> File (Max: 25MB) </span>
      <span class="dimensions" *ngIf="allowedTypes">Allowed Types : {{allowedTypes.join(',')}}</span>
    </p>
    <img src="../../../../../../../assets/images/icons/file.svg" alt="">
    <input type="file" class="file_input" #fileVariable (change)="setFiles(fileVariable.files)">
  </div>
  <div class="uploaded_img">
    <ul>
      <li *ngIf="fileInput.value  && type === 'IMAGE'">
        <img [src]="fileInput.value.url" alt="" class="preview_img">
        <div class="close_img">
          <img src="../../../../../assets/images/icons/close.svg" alt="" (click)="removeUrl()">
        </div>
      </li>
      <li *ngIf="fileInput.value && type === 'VIDEO'" >
        <video [src]="fileInput.value.url" controls class="video_preview"> </video>
        <div class="close_img">
          <img src="../../../../../assets/images/icons/close.svg" alt="" (click)="removeUrl()">
        </div>
      </li>
      <li *ngIf="fileInput.value && type === 'FILE'" >
        <img src="/assets/images/icons/file_icon.svg" alt="" class="preview_img">
        <div class="close_img">
          <img src="../../../../../assets/images/icons/close.svg" alt="" (click)="removeUrl()">
        </div>
      </li>
    </ul>
    <ng-container *ngIf="file">
      <app-single-upload [singleFile]="file" (output)="addFile($event)"></app-single-upload>
    </ng-container>
  </div>
</div>
